import React from 'react';
import styled from 'styled-components';
import useTranslation from '@src/hooks/useTranslation';

import useCurrentCourse from '@src/hooks/useCurrentCourse';
import Header from '@src/components/common/header';
import { BlockWrapper } from '@src/components/common/commonStyle';

const WhatWillLearnWrapper = styled(BlockWrapper)`
	padding-bottom: 40px;

	@media ${props => props.theme.device.smTablet} {
		padding-bottom: 32px;
	}

	@media ${props => props.theme.device.mobile} {
		padding-bottom: 32px;
	}
`;

const Content = styled.div`
	padding: 0 140px;
	white-space: pre-line;
	line-height: 36px;
	color: #101010;

	@media ${props => props.theme.device.lgDesktop} {
		font-size: 18px;
		padding: 0px 56px;
	}

	@media ${props => props.theme.device.desktop} {
		font-size: 18px;
		padding: 0px 56px;
	}

	@media ${props => props.theme.device.tablet} {
		font-size: 18px;
		padding: 0px 8px;
	}

	@media ${props => props.theme.device.smTablet} {
		padding: 0px 4px;
	}

	@media ${props => props.theme.device.mobile} {
		padding: 0px 12px;
	}
`;

const WhatWillLearn = (): JSX.Element => {
	const { t } = useTranslation();
	const { currentCourse: { outcome } } = useCurrentCourse();
	if (!outcome) return null;
	return (
		<WhatWillLearnWrapper>
			<Header text={t('course:information:what_will_learn')} />
			<Content>{outcome}</Content>
		</WhatWillLearnWrapper>
	);
};

export default WhatWillLearn;
